import React, {useState} from 'react'
import {Button} from './Button'
import {ArrowRight} from './icons'
import {signupModalHref} from './constants'
import checkCircleIcon from '../../images/icons/check-circle-regular.svg'
import videoIcon from '../../images/icons/video-regular.svg'

const heroCards = [
  {key: 'offers', label: 'Offer board', kicker: 'Live', kickerColor: '#16a34a', meta: '3 of 5 offers'},
  {key: 'package', label: 'Listing package', kicker: 'Branded', kickerColor: '#0c6eba', meta: 'Ready to send'},
  {key: 'activity', label: 'Buyer activity', kicker: 'Hot', kickerColor: '#c2410c', meta: 'Last 24 hours'},
  {key: 'disclosures', label: 'Disclosure package', kicker: 'Tracking', kickerColor: '#0c6eba', meta: '4 of 5 done'},
]

export function OfferBoardMock({includeFooter = false} = {}) {
  const rows = [
    {who: 'Gregory Scott', price: '$1,500,000', terms: 'Cash - 18d close', status: 'New'},
    {who: 'Victoria Sato', price: '$1,450,000', terms: 'Loan - 30d close', status: 'Counter'},
    {who: 'Sam Jackson', price: '$1,447,000', terms: 'Loan - 45d close', status: 'Active'},
  ]

  return (
    <>
      <div className="hlm-offer-rows">
        {rows.map((row, index) => (
          <div className="hlm-offer-row" key={row.who}>
            <div className="hlm-rank">#{index + 1}</div>
            <div className="hlm-offer-meta">
              <div className="hlm-row-title">{row.who}</div>
              <div className="hlm-row-sub">{row.terms}</div>
            </div>
            <div className="hlm-price">
              <div className="hlm-price-amount">{row.price}</div>
              <span className={`hlm-pill ${index === 0 ? 'hlm-pill-green' : 'hlm-pill-blue'}`}>{row.status}</span>
            </div>
          </div>
        ))}
      </div>
      {includeFooter && (
        <div className="hlm-card-footer">
          <div>
            <div className="hlm-card-footer-label">Top vs. Ask</div>
            <div className="hlm-card-footer-copy hlm-card-footer-copy-light">+$20,000</div>
          </div>
          <button className="hlm-card-footer-button" type="button">
            Compare offers
          </button>
        </div>
      )}
    </>
  )
}

export function PackageMock({includeFooter = false} = {}) {
  const docs = [
    ['Cover & marketing brochure', '8 pages'],
    ['CMA & pricing strategy', '12 comps'],
    ['21-point marketing plan', 'PDF'],
    ['Net-proceeds estimate', '$1.13M'],
  ]

  return (
    <>
      <div className="hlm-package-grid">
        <div className="hlm-package-cover">
          <div className="hlm-package-presented">PRESENTED BY</div>
          <div className="hlm-package-agent">Marissa Chen</div>
          <div className="hlm-package-address">2847 Crestwood</div>
          <div className="hlm-package-city">AUSTIN, TX</div>
        </div>
        <div className="hlm-doc-rows">
          {docs.map(doc => (
            <div className="hlm-doc-row hlm-package-doc-row" key={doc[0]}>
              <div className="hlm-doc-icon" aria-hidden="true" />
              <div>
                <div className="hlm-row-title">{doc[0]}</div>
                <div className="hlm-row-sub">{doc[1]}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {includeFooter && (
        <div className="hlm-card-footer">
          <div>
            <div className="hlm-card-footer-label">Distribution</div>
            <div className="hlm-card-footer-copy">MLS · Email · Custom link</div>
          </div>
          <button className="hlm-card-footer-button" type="button">
            Share package
          </button>
        </div>
      )}
    </>
  )
}

export function ActivityMock() {
  const stats = [
    ['412', 'Pkg views', '+38%'],
    ['87', 'Downloads', '+24%'],
    ['14', 'Agents', '+5'],
  ]
  const agents = [
    {who: 'Brooks Realty Group', views: 14, when: '2 hr ago', hot: true},
    {who: 'Garcia & Co.', views: 8, when: '4 hr ago', hot: true},
    {who: 'Northstar Properties', views: 5, when: 'yesterday', hot: false},
  ]

  return (
    <>
      <div className="hlm-activity-stats">
        {stats.map(stat => (
          <div className="hlm-stat-card" key={stat[1]}>
            <strong>{stat[0]}</strong>
            <div className="hlm-stat-label">{stat[1]}</div>
            <div className="hlm-stat-delta">{stat[2]}</div>
          </div>
        ))}
      </div>
      <div className="hlm-activity-rows">
        {agents.map(agent => (
          <div className={`hlm-activity-row ${agent.hot ? 'is-hot' : ''}`} key={agent.who}>
            <div>
              <div className="hlm-row-title">{agent.who}</div>
              <div className="hlm-row-sub">
                {agent.views} views · {agent.when}
              </div>
            </div>
            <span className={`hlm-pill ${agent.hot ? 'hlm-pill-orange' : 'hlm-pill-grey'}`}>{agent.hot ? 'Hot' : 'Watch'}</span>
          </div>
        ))}
      </div>
    </>
  )
}

export function DisclosureMock({includeFooter = false} = {}) {
  const docs = [
    ['Seller Property Disclosure (TDS)', 'Signed', 'hlm-pill-green'],
    ['Lead-Based Paint Disclosure', 'Signed', 'hlm-pill-green'],
    ['Natural Hazards Report', 'Sent', 'hlm-pill-blue'],
    ['HOA CC&Rs', 'Pending', 'hlm-pill-orange'],
    ['Preliminary Title Report', 'Signed', 'hlm-pill-green'],
  ]

  return (
    <>
      <div className="hlm-progress">
        <span style={{width: '80%'}} />
      </div>
      <div className="hlm-doc-rows">
        {docs.map(doc => (
          <div className="hlm-doc-row" key={doc[0]}>
            <div className="hlm-row-title">{doc[0]}</div>
            <span className={`hlm-pill ${doc[2]}`}>{doc[1]}</span>
          </div>
        ))}
      </div>
      {includeFooter && (
        <div className="hlm-card-footer">
          <div>
            <div className="hlm-card-footer-label">Audit trail</div>
            <div className="hlm-card-footer-copy">148 events · tamper-proof</div>
          </div>
          <button className="hlm-card-footer-button" type="button">
            Export PDF
          </button>
        </div>
      )}
    </>
  )
}

function HeroCard() {
  const [active, setActive] = useState(0)
  const [phase, setPhase] = useState('idle')
  const card = heroCards[active]

  const goTo = next => {
    if (next === active || phase !== 'idle') return
    setPhase('leaving')
    setTimeout(() => {
      setActive(next)
      setPhase('entering')
      setTimeout(() => setPhase('idle'), 420)
    }, 320)
  }

  return (
    <div className="hlm-hero-card-wrap">
      <div className="hlm-card-back" aria-hidden="true" />
      <div className="hlm-card-back two" aria-hidden="true" />
      <div className={`hlm-hero-card hlm-phase-${phase}`}>
        <div className="hlm-card-top">
          <div className="hlm-card-kicker" style={{color: card.kickerColor}}>
            <span className="hlm-live-dot" style={{background: card.kickerColor}} />
            {card.kicker}
            <span className="hlm-card-label">{card.label}</span>
          </div>
          <div className="hlm-card-meta">{card.meta}</div>
        </div>
        {card.key === 'offers' && <OfferBoardMock includeFooter />}
        {card.key === 'package' && <PackageMock includeFooter />}
        {card.key === 'activity' && <ActivityMock />}
        {card.key === 'disclosures' && <DisclosureMock includeFooter />}
      </div>
      <div className="hlm-pagers">
        {heroCards.map((item, index) => (
          <button key={item.key} type="button" className={index === active ? 'is-active' : ''} aria-label={`Show ${item.label}`} onClick={() => goTo(index)} />
        ))}
      </div>
    </div>
  )
}

function HeroV2({onDemo}) {
  return (
    <section className="hlm-hero">
      <div className="hlm-hero-bg" />
      <div className="hlm-container hlm-hero-grid">
        <div className="hlm-hero-copy">
          <div className="hlm-eyebrow hlm-eyebrow-green">Trusted by listing teams nationwide</div>
          <h1 className="hlm-hero-h1">
            The Smarter Way to
            <br />
            <span>Manage Listings</span>
          </h1>
          <p className="hlm-lede">
            Offers, disclosures, listing packages, and buyer interest reports — all in one place. The simplest way to manage every active listing from sign to
            close.
          </p>
          <div className="hlm-hero-ctas">
            <Button href={signupModalHref} size="lg">
              Try it for free
              <ArrowRight />
            </Button>
            <Button variant="secondary" size="lg" onClick={onDemo}>
              <span className="hlm-video-icon" style={{'--hlm-video-icon': `url(${videoIcon})`}} aria-hidden="true" />
              Watch Demo
            </Button>
          </div>
          <div className="hlm-trust-list">
            <span className="hlm-check">
              <img src={checkCircleIcon} alt="" aria-hidden="true" />
              14-day free trial
            </span>
            <span className="hlm-check">
              <img src={checkCircleIcon} alt="" aria-hidden="true" />
              Cancel anytime
            </span>
            <span className="hlm-check">
              <img src={checkCircleIcon} alt="" aria-hidden="true" />
              No credit card
            </span>
          </div>
        </div>
        <HeroCard />
      </div>
    </section>
  )
}

export default HeroV2
